import colour from "@/assets/cart10-marketing-logo.png";
import white from "@/assets/cart10-marketing-logo-white.png";

/**
 * The Cart10 Marketing wordmark.
 *
 * Two files, one shape. Both are real alpha cutouts derived from the same
 * matte — the white one replaces only the RGB — so the letterforms cannot
 * drift apart.
 *
 * Which to use is about contrast, not taste. The metallic gradient is handsome
 * on a light background, but on the dark sidebar its darkest tones sit a few
 * levels above the surface and the mark reads as grey on black. `white` is for
 * dark surfaces; the default is for light ones.
 *
 * `alt` is empty wherever the product name is already in the DOM beside it, so
 * a screen reader does not announce "Cart10 Marketing" twice.
 */
export function Logo({
  className = "h-7",
  alt = "",
  white: onDark = false,
}: {
  className?: string;
  alt?: string;
  white?: boolean;
}) {
  return <img src={onDark ? white : colour} alt={alt} className={`w-auto ${className}`} />;
}
